import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatasetIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M11 13H7V17H11V13Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M17 13H13V17H17V13Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M11 7H7V11H11V7Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M17 7H13V11H17V7Z" })
		]
	})
});
export default SvgDatasetIcon;
